
export const tutorials = {
  'backoffice.sidebarUser.sections.tutorials.items.theClubRegistration': 'Registro en The Club',

  // Tutorials Index Page
  'tutorials.index.title': 'Centro de Aprendizaje',
  'tutorials.index.subtitle': 'Guías paso a paso para ayudarte a comenzar',

  // Common
  'tutorials.common.downloadPdf': 'Descargar Guía PDF',
  'tutorials.common.pdfAlternative': 'Descarga nuestra guía completa en PDF',
  'tutorials.common.watchVideo': 'Ver Video Tutorial',
  'tutorials.common.pdfName': 'TheClub_Guia_Registro_ES.pdf',

  // Tutorial: Radex Markets Registration
  'tutorials.radexRegistration.title': 'Registro en Radex Markets Broker',
  'tutorials.radexRegistration.description': 'Aprende cómo abrir y configurar tu cuenta en Radex Markets, el broker socio regulado de TheClub. Esta guía cubre la creación de cuenta, presentación de documentos y verificación de identidad.',
  'tutorials.radexRegistration.links.registration': 'Registro en Radex Markets',

  // Tutorial: Wire Transfer
  'tutorials.wireTransfer.title': 'Financiar Cuenta mediante Transferencia Bancaria',
  'tutorials.wireTransfer.description': 'Un recorrido completo sobre cómo financiar tu cuenta de Radex Markets mediante transferencia bancaria. Cubre datos bancarios, tiempos de procesamiento y pasos de confirmación.',
  'tutorials.wireTransfer.links.login': 'Inicio de Sesión Radex Markets',

  // Tutorial: Card Funding
  'tutorials.cardFunding.title': 'Financiar Cuenta con Tarjeta de Crédito/Débito',
  'tutorials.cardFunding.description': 'Un recorrido completo sobre cómo financiar tu cuenta de Radex Markets usando una tarjeta de crédito o débito Visa o Mastercard. Rápido, seguro y listo en minutos.',
  'tutorials.cardFunding.links.login': 'Inicio de Sesión Radex Markets',

  // Tutorial: PAMM Registration
  'tutorials.pammRegistration.title': 'Registro en la Cuenta PAMM de TheClub',
  'tutorials.pammRegistration.description': 'Aprende cómo vincular tu cuenta de Radex Markets al sistema PAMM de TheClub para que tus fondos sean gestionados por nuestros traders profesionales.',
  'tutorials.pammRegistration.links.institutional': 'PAMM Account Trading Institucional',
  'tutorials.pammRegistration.links.spartan': 'PAMM Account Spartan AI Trading',
  'tutorials.pammRegistration.links.login': 'Inicio de Sesión PAMM Account',

  // Tutorial: TheClub Account Creation
  'tutorials.theclubAccount.title': 'Crear la Cuenta de TheClub',
  'tutorials.theclubAccount.description': 'Instrucciones paso a paso para crear tu cuenta de membresía en TheClub — desde el registro en la plataforma hasta completar la asociación con tu PAMM account.',
  'tutorials.theclubAccount.links.registration': 'Página de Registro TheClub',
  'tutorials.theclubAccount.links.registrationNote': 'Usa el enlace proporcionado por tu Sponsor',
  'tutorials.theclubAccount.links.website': 'Sitio Web TheClub',
};
